import { TransactionApiUrls } from "@/modules/transaction/common/enum";
import type {
  ICreateLoanRepaymentRequest,
  ILoanRepayment,
  ISaveAsTemplate,
  IUpdateLoanRepaymentRequest
} from "@/modules/transaction/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const loanRepaymentApi = createApi({
  reducerPath: "loanRepaymentApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getLoanRepayment: builder.query<ILoanRepayment, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${TransactionApiUrls.LoanRepaymentV2}/${id}`,
      }),
    }),
    createLoanRepayment: builder.mutation<string, ICreateLoanRepaymentRequest>(
      withIdempotency<ICreateLoanRepaymentRequest>(
        TransactionApiUrls.LoanRepaymentV2
      )),
    updateLoanRepayment: builder.mutation<string, IUpdateLoanRepaymentRequest>({
      query: ({ data, id }) => ({
        url: `${TransactionApiUrls.LoanRepaymentV2}/${id}`,
        method: "PUT",
        data,
      }),
    }),
    saveLoanRepaymentAsTemplate: builder.mutation<string, ISaveAsTemplate>({
      query: ({ id, name, idempotencyKey }) => ({
        url: `${TransactionApiUrls.LoanRepaymentV2}/${id}/Templates`,
        method: "POST",
        headers: { "Idempotency-Key": idempotencyKey },
        data: { name },
      }),
    }),
  }),
});

export const {
  useGetLoanRepaymentQuery,
  useCreateLoanRepaymentMutation,
  useUpdateLoanRepaymentMutation,
  useSaveLoanRepaymentAsTemplateMutation,
} = loanRepaymentApi;
